// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
import React, { useCallback, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { compareArray } from '../../../../utils/common'
import { dropdownContainerStyle, multiSelectDropdownStyles, TAG_OPTIONS } from '../Constants'
// @ts-expect-error TS7016 -- MIGRATION: not approved, fix when encountered
import { MultiSelectDropdown } from 'ui_kit_qmd'
import { NO_RESULTS_TEXT } from '../../../../utils/constants'

// @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
export const useMediaFiles = ({ id }) => {
  // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
  const mediaFiles = useSelector((state) => state.chartsReducer.patientInfo?.[id]?.mediaFiles || [], compareArray)
  const [tagsList, setTagsList] = useState(TAG_OPTIONS)
  const [tagsSelected, setTagsSelected] = useState('')
  const [filteredMediaFiles, setFilteredMediaFiles] = useState(mediaFiles)

  const onSetTagsSelected = useCallback(
    // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
    (value) => {
      if (value) {
        setFilteredMediaFiles(() =>
          // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
          mediaFiles.filter((file) => {
            let found = false
            for (const tag in file.Tags) {
              if (value.includes(file.Tags[tag])) {
                found = true
                continue
              }
            }
            return found
          }),
        )
      } else {
        setFilteredMediaFiles(mediaFiles)
      }
      setTagsSelected(value)
    },
    [mediaFiles],
  )

  useEffect(() => {
    onSetTagsSelected(tagsSelected)
  }, [mediaFiles])

  const getTagFilter = useCallback(
    () => (
      <div className='file-section-multiselect-dropdown-container'>
        <MultiSelectDropdown
          className='file-section-multiselect-dropdown'
          containerStyle={multiSelectDropdownStyles}
          dropdownContainerStyle={dropdownContainerStyle}
          options={tagsList}
          value={tagsSelected}
          setValue={onSetTagsSelected}
          setOptions={setTagsList}
          dropId='filter-tags'
          label='Tags'
          customEmptyMessage={NO_RESULTS_TEXT}
          isWithSearch
        />
      </div>
    ),
    [onSetTagsSelected, tagsList, tagsSelected],
  )

  return { filteredMediaFiles, mediaFiles, getTagFilter }
}
